

import React, { memo } from 'react';
import moment from 'moment';
import { EVENT_ICON, EVENTS } from '@shootsta/event';
import { Avatar, Icon, Text } from '../../../ui-kit';
import STATUS from '../constants/status';
import { getTimestampFromCreatedDate } from '../utils';
import '../styles/_event-item.scss';

const replaceFields = (str, fields) => Object.entries(fields).reduce(
  (replacedString, [key, value]) => replacedString.replace(new RegExp(key, 'g'), value),
  str);

const getUserDisplayName = (user) => `${user.firstName} ${user.lastName}`;







const renderSideIcon = (
isV2Design,
editorId,
user,
eventIcon) =>
{
  if (isV2Design) {
    if (editorId === user.userId) {
      return <Icon name="shootstacolour" size={24} />;
    }
    return (
      <Avatar
        width={24}
        height={24}
        placeholderText={getUserDisplayName(user)}
        placeholderTextSize={10} />);


  }
  return <Icon name={eventIcon} color="monkey" size={24} />;
};

function EventItem({ event, editorId, isV2Design = false }) {
  const { createdByGhostUser, createdByUser, metaData, eventType, createdAt } = event;

  const user = createdByGhostUser || createdByUser;

  const { status, version, editor, owner, appliedAddonsCount } = metaData || {};

  const eventContent = EVENTS[eventType];

  if (!eventContent || !eventContent.message) {return null;}

  const message = replaceFields(eventContent.message, {
    '{userName}': `${user.firstName} ${user.lastName}`,
    '{status}': STATUS[status],
    '{version}': version,
    '{editorName}': editor ? `${editor.firstName} ${editor.lastName}` : '',
    '{ownerName}': owner ? `${owner.firstName} ${owner.lastName}` : '',
    '{appliedAddonsCount}': appliedAddonsCount || ''
  });

  const eventIcon = createdByGhostUser ? EVENT_ICON.GHOST : eventContent.icon;
  const createdAtDate = moment(createdAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']);

  return (
    <div className="event-item">
      <div className="event-item__side">
        {renderSideIcon(isV2Design, editorId, user, eventIcon)}
        <div className="event-item__side__line" />
      </div>
      <div className="event-item__content">
        <Text heading5 noMargin>{getUserDisplayName(user)}</Text>
        <Text label>{message}</Text>
        <Text timestamp>
          {isV2Design ?
          createdAtDate.format('h:mma  MMM D YYYY') :
          getTimestampFromCreatedDate(createdAtDate)}
        </Text>
      </div>
    </div>);

}

export default memo(EventItem);